import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import logo from "../../Static/images/logo.png";
import { SearchesCIcon, SpinnerIcon } from "../../Static/icons/iconshere";
import { usePageTitle } from "../PageTitleContext";
import NoDataFound from "../Quiz/NoDataFound/NoDataFound";
import { useNavigate } from "react-router-dom";
import apiClient from "../../apiClient";
import { CREATE_AR_MODULE, FETCH_AR_MODULE_LIST } from "../../apiClient/apiEndpoints";
import { useSelector } from "react-redux";
import { checkUserAllowPermissions } from "../../utils/common";
import { CONTENT_AR_CREATE } from "../../constant/Permissions";

const ArList = () => {
  const { setPageTitle } = usePageTitle();
  const navigate = useNavigate();
  const configData = useSelector((state) => state.configSlice);
  const UNO_URL = configData?.config?.UNO_URL;
  const [arModuleList, setArModuleList] = useState([]);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const [moduleForm, setModuleForm] = useState({
    name: "",
  });
  const [showModal, setShowModal] = useState({
    createModule: false,
  });
  const [loading, setLoading] = useState({
    page: true,
    createArModule: false,
  });

  const fetchArModules = async () => {
    try {
      const res = await apiClient.get(`${UNO_URL}${FETCH_AR_MODULE_LIST}`);
      setArModuleList(res);
    } catch (error) {
      console.log(`Error while fetching the AR Module list ${error}`);
    }
  };

  const initializePage = async () => {
    setLoading((prev) => ({ ...prev, page: true }));
    await fetchArModules();
    setLoading((prev) => ({ ...prev, page: false }));
  };

  const createArModule = async () => {
    try {
      if (!moduleForm.name.trim()) {
        setError("Invalid Name");
        return;
      }
        
      setError("");
      const payload = {
        moduleName: moduleForm.name,
      };
      setLoading((prev) => ({ ...prev, createArModule: true }));
      const response = await apiClient.post(`${UNO_URL}${CREATE_AR_MODULE}`, payload);
      closeCreateModuleModal();
      navigate(`/dashboard/ar/details/${response.uuid}`);
    } catch (error) {
      console.log(`Error while creating ar module ${error}`);
    } finally {
      setLoading((prev) => ({ ...prev, createArModule: false }));
    }
  };

  const closeCreateModuleModal = () => {
    setModuleForm({ name: "" });
    setShowModal((prev) => ({ ...prev, createModule: false }));
  };
  const openCreateModuleModal = () => {
    if (!checkUserAllowPermissions(CONTENT_AR_CREATE)) return;
    setShowModal((prev) => ({ ...prev, createModule: true }));
  };

  const handleEditARDetails = (uuid) => {
    if (!checkUserAllowPermissions(CONTENT_AR_CREATE)) return;
    navigate(`/dashboard/ar/details/${uuid}`)
  };

  useEffect(() => {
    setPageTitle("AR Content Library");
    initializePage();
  }, []);

  const filteredList = arModuleList?.filter((module) => module.name?.toLowerCase().includes(search?.trim()?.toLowerCase()));

  return (
    <>
      <div className="stuckhere modules">
        <div className="row">
          <div className="col-md-6">
            <form className=" app-search app-search1 d-flex justify-content-start ">
              <div className="position-relative">
                <SearchesCIcon />
                <input
                  type="text"
                  name="searchName"
                  className="form-control"
                  placeholder="Search "
                  autoComplete="off"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </form>
          </div>
          <div className="col-md-6  d-flex gap-3 align-items-center justify-content-end mainbtns">
            {checkUserAllowPermissions(CONTENT_AR_CREATE) &&
              <button className="createbtn" onClick={openCreateModuleModal}>
                Add AR Module
              </button>}
          </div>
        </div>
      </div>
      <div className="lowersection">
        <div className="container-fluid px-4">
          {loading.page ? (
            <div className="modulelist">
              <NoDataFound text="Data is fetching...." />
            </div>
          ) : (
            <>
              {filteredList?.length > 0 ? (
                <div className="modulelist">
                  <div className="course-tiles">
                    {filteredList?.map((module) => (
                      <div
                        className="tilecard"
                        onClick={() => handleEditARDetails(module.uuid)}
                        key={module.uuid}
                      >
                        <div className="modulecard module">
                          <div className="cursor-pointer">
                            <div className="moduleleft d-block">
                              <div className="moduleicon">
                                <img src={module.thumbnail || logo} className="defaultimg" alt="Default Thumbnail" />
                              </div>
                              <div className="moduledata">
                                <p className="modulename">{module.name}</p>
                                <p className="moduledes">{module.description}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <NoDataFound text="No Data Found" />
              )}
            </>
          )}
        </div>
      </div>

      <Modal show={showModal.createModule} size="md" centered onHide={closeCreateModuleModal}>
        <Modal.Body className="NewModule p-4">
          <div className="container-fluid">
            <div className="row quizmodalhead">
              <div className="col-md-12 text-center">
                <h5 className="headquiz">Add Content</h5>
              </div>
            </div>
            <div className="row my-4">
              <div className="col-12">
                <div className="form-group">
                  <label className="label pb-2">Name</label>
                  <input
                    autoComplete="off"
                    placeholder="Name"
                    className="input form-control"
                    type="text"
                    value={moduleForm.name}
                    onChange={(e) => setModuleForm((prev) => ({ ...prev, name: e.target.value }))}
                  />
                  <p className="error"> {error} </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="text-end footerbtn text-end">
              <button onClick={closeCreateModuleModal}>Cancel</button>
              {loading.createArModule ? (
                <button>
                  <SpinnerIcon />
                </button>
              ) : (
                <button onClick={createArModule}>Add</button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ArList;
